import React from 'react';
import PageContainer from '../../components/PageContainer/index';
import { TabPanel, TabPanels } from '@chaser/components';
import NavigationTabs from '../../components/NavigationTabs';
import Organisations from './Organisations';
import FeatureTest from './FeatureTest';
import Settings from './Settings';
import { roles } from '../../util/constants';
import RoleGate from '../../components/FeatureGate/RoleGate';

const Admin = () => {
  return (
    <RoleGate roles={[roles.admin]}>
      <PageContainer>
        <NavigationTabs
          basePath="/admin"
          tabs={[
            { path: 'organisations', title: 'Organisations' },
            { path: 'features', title: 'Features' },
            { path: 'settings', title: 'Settings' },
          ]}
        >
          <TabPanels>
            <TabPanel>
              <Organisations />
            </TabPanel>
            <TabPanel>
              <FeatureTest />
            </TabPanel>
            <TabPanel>
              <Settings />
            </TabPanel>
          </TabPanels>
        </NavigationTabs>
      </PageContainer>
    </RoleGate>
  );
};

export default Admin;
